import { Vue2, isVue2, createApp } from 'vue-demi';
export function useExtend(component) {
  let propsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let instance;
  let unmount;
  const root = document.createElement('div');
  if (isVue2) {
    instance = new (Vue2.extend(component))({
      el: root,
      propsData
    });
    unmount = () => {
      var _instance$$el;
      instance.$destroy();
      (_instance$$el = instance.$el) === null || _instance$$el === void 0 || (_instance$$el = _instance$$el.parentNode) === null || _instance$$el === void 0 || _instance$$el.removeChild(instance.$el);
    };
  } else {
    const vm = createApp(component, propsData);
    instance = vm.mount(root);
    unmount = () => {
      vm.unmount();
    };
  }
  return {
    instance,
    unmount
  };
}